export default "__VITE_ASSET__DSfSQMAD__"